import { auth } from '../firebase-config';

/**
 * Get authentication headers with Firebase JWT token
 * @returns {Promise<Object>} Headers object with Authorization bearer token
 * @throws {Error} If user is not authenticated
 */
export const getAuthHeaders = async () => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }
  const idToken = await user.getIdToken();
  return {
    'Authorization': `Bearer ${idToken}`,
    'Content-Type': 'application/json'
  };
};

/**
 * Get authentication headers without Content-Type (for form data, etc.)
 * @returns {Promise<Object>} Headers object with Authorization bearer token only
 * @throws {Error} If user is not authenticated
 */
export const getAuthHeadersOnly = async () => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('User not authenticated');
  }
  const idToken = await user.getIdToken();
  return {
    'Authorization': `Bearer ${idToken}`
  };
};
